import React, { useEffect } from 'react';
// Box was removed from the list below to fix the warning
import { Container, Typography, Button, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

export default function GoodbyePage() {
  useEffect(() => {
    document.title = "Account Deleted | Christmas Lights Map";
  }, []);

  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
        <SentimentVeryDissatisfiedIcon color="action" sx={{ fontSize: 80, mb: 2, opacity: 0.5 }} />
        
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
          Account Deleted
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          We're sorry to see you go! Your account, login credentials, and all 
          Christmas light displays have been permanently removed from our 2025 database.
        </Typography>

        <Typography variant="body2" sx={{ mb: 4, fontStyle: 'italic' }}>
          Thank you for being part of the festive community this year.
        </Typography>

        <Button 
          variant="contained" 
          color="primary" 
          component={RouterLink} 
          to="/" 
          startIcon={<HomeIcon />}
          fullWidth
        >
          Return to Live Map
        </Button>
      </Paper>
    </Container>
  );
}